import type { PlanId } from 'Billing/Catalog';
import type { CdvPurchaseOffer, CdvPurchaseProduct, CdvPricingPhase } from './initPurchases';

const PERIODS: Record<PlanId, string> = { monthly: 'P1M', '3-months': 'P3M', annual: 'P1Y' };
export interface RecurringOffer {
  offer: CdvPurchaseOffer;
  phase: CdvPricingPhase;
}

/** Do not let getOffer() implicitly select a free trial, prepaid plan, or promotional offer. */
export function selectRecurringOffer(
  product: CdvPurchaseProduct | undefined,
  plan: PlanId,
): RecurringOffer | undefined {
  if (!product?.canPurchase) return;
  const offers =
    product.offers ?? [product.getOffer?.()].filter((offer): offer is CdvPurchaseOffer => !!offer);
  const candidates = offers.filter((offer) => {
    const phases = offer.pricingPhases;
    if (offer.canPurchase === false || phases?.length !== 1) return false;
    const phase = phases[0];
    return (
      phase.recurrenceMode === 'INFINITE_RECURRING' &&
      (phase.billingPeriod === PERIODS[plan] ||
        (plan === 'annual' && phase.billingPeriod === 'P12M')) &&
      Number.isSafeInteger(phase.priceMicros) &&
      phase.priceMicros > 0 &&
      !!phase.price &&
      /^[a-z]{3}$/i.test(phase.currency)
    );
  });
  // An ambiguous catalog must be fixed in the store, never resolved by array ordering.
  if (candidates.length !== 1) return;
  return { offer: candidates[0], phase: candidates[0].pricingPhases![0] };
}
